import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const SunIcon: React.FC<IconProps> = props => {
  return (
    <BaseIcon viewboxSize="md" {...props}>
      <path
        clipRule="evenodd"
        d="M10 3.125C10.3452 3.125 10.625 3.40482 10.625 3.75V5C10.625 5.34518 10.3452 5.625 10 5.625C9.65482 5.625 9.375 5.34518 9.375 5V3.75C9.375 3.40482 9.65482 3.125 10 3.125Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10 14.375C10.3452 14.375 10.625 14.6548 10.625 15V16.25C10.625 16.5952 10.3452 16.875 10 16.875C9.65482 16.875 9.375 16.5952 9.375 16.25V15C9.375 14.6548 9.65482 14.375 10 14.375Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3.125 10C3.125 9.65482 3.40482 9.375 3.75 9.375H5C5.34518 9.375 5.625 9.65482 5.625 10C5.625 10.3452 5.34518 10.625 5 10.625H3.75C3.40482 10.625 3.125 10.3452 3.125 10Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.375 10C14.375 9.65482 14.6548 9.375 15 9.375H16.25C16.5952 9.375 16.875 9.65482 16.875 10C16.875 10.3452 16.5952 10.625 16.25 10.625H15C14.6548 10.625 14.375 10.3452 14.375 10Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.13128 5.13128C5.37496 4.8876 5.77004 4.8876 6.01372 5.13128L6.89645 6.01401C7.14013 6.25769 7.14013 6.65277 6.89645 6.89645C6.65277 7.14013 6.25769 7.14013 6.01401 6.89645L5.13128 6.01372C4.8876 5.77004 4.8876 5.37496 5.13128 5.13128Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.1036 13.1036C13.3472 12.8599 13.7423 12.8599 13.986 13.1036L14.8687 13.9863C15.1124 14.23 15.1124 14.625 14.8687 14.8687C14.625 15.1124 14.23 15.1124 13.9863 14.8687L13.1036 13.986C12.8599 13.7423 12.8599 13.3472 13.1036 13.1036Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.8687 5.13128C15.1124 5.37496 15.1124 5.77004 14.8687 6.01372L13.986 6.89645C13.7423 7.14013 13.3472 7.14013 13.1036 6.89645C12.8599 6.65277 12.8599 6.25769 13.1036 6.01401L13.9863 5.13128C14.23 4.8876 14.625 4.8876 14.8687 5.13128Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.89645 13.1036C7.14013 13.3472 7.14013 13.7423 6.89645 13.986L6.01372 14.8687C5.77004 15.1124 5.37496 15.1124 5.13128 14.8687C4.8876 14.625 4.8876 14.23 5.13128 13.9863L6.01401 13.1036C6.25769 12.8599 6.65277 12.8599 6.89645 13.1036Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5ZM6.25 10C6.25 7.92893 7.92893 6.25 10 6.25C12.0711 6.25 13.75 7.92893 13.75 10C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 10Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
